import type { NavigateFunction, NavigateOptions, To } from "react-router";

/**
 * Fire a react-router navigation and ignore its result. Data routers return
 * a promise whose rejection (e.g. an aborted transition) would otherwise
 * surface as an unhandled rejection; hash-router navigate returns void. One
 * shared convention instead of per-site `instanceof Promise` checks and
 * no-floating-promises suppressions.
 */
export function navigateAndForget(
  navigate: NavigateFunction,
  to: To,
  options?: NavigateOptions
): void {
  const result: void | Promise<void> = navigate(to, options);
  if (result instanceof Promise) result.catch(() => undefined);
}
